import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const guardState = {
  active: false,
  hash: '',
  history: null,
  message: '',
  pathname: '',
  search: '',
  skip: false,
};

const handlePopState = (event) => {
  if (!guardState.active || !guardState.history) {
    return;
  }

  if (guardState.skip) {
    guardState.skip = false;
    return;
  }

  const shouldLeave = window.confirm(guardState.message);
  if (shouldLeave) {
    return;
  }

  event.stopImmediatePropagation();
  const { pathname, search, hash, history } = guardState;
  history.replace(`${pathname}${search}${hash}`);
};

window.addEventListener('popstate', handlePopState, true);

/** Call before history.goBack() when the user already confirmed via Indietro. */
export function skipNextNavigationGuard() {
  guardState.skip = true;
}

/**
 * Blocks browser-back navigation while `isActive` is true.
 * Indietro uses skipNextNavigationGuard() to avoid a second confirm on goBack().
 * The popstate listener is registered when this module is first imported
 * (e.g. via DettaglioEsercizioCommerciale → UnsavedChangesNavigationGuard).
 */
export function useUnsavedChangesNavigationGuard(isActive, message) {
  const history = useHistory();

  useEffect(() => {
    if (!isActive) {
      if (guardState.history === history) {
        guardState.active = false;
      }
      return undefined;
    }

    guardState.active = true;
    guardState.message = message;
    guardState.pathname = history.location.pathname;
    guardState.search = history.location.search;
    guardState.hash = history.location.hash;
    guardState.history = history;

    return () => {
      if (guardState.history === history) {
        guardState.active = false;
        guardState.history = null;
      }
    };
  }, [history, isActive, message]);
}
